import { render } from "./PackageView.vue?vue&type=template&id=6a06ab60&scoped=true"
import script from "./PackageView.vue?vue&type=script&lang=js"
export * from "./PackageView.vue?vue&type=script&lang=js"

import "./PackageView.vue?vue&type=style&index=0&id=6a06ab60&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a06ab60"]])

export default __exports__